<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div class="bg-no-repeat bg-cover bg-center h-full min-h-full" style="background-image: url('assets/images/maintenance.webp')">
  <myprofile-signup-ui-navigation navMode="hero" navTheme="dark"></myprofile-signup-ui-navigation>
  <main
    id="main-content"
    class="pb-fluid-lg"
    style="
      background-image: linear-gradient(
        to bottom,
        rgba(35, 25, 23, 0) 5%,
        rgba(35, 25, 23, 0.2) 20%,
        rgba(35, 25, 23, 0.3) 85%,
        rgba(35, 25, 23, 0) 100%
      );
    "
  >
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
    it won't register the changes on the layout and won't update the view. -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </main>
</div>
